import { SearchItemWithImageViewModel } from '@/types/api';
import { AppNextLink } from '@/features/app-next-link';
import { useDrawer } from '@/features/drawer/context/use-drawer';
import { useUserToken } from '@/app/_utils/session';
import { sendCardDataClickEvent } from '@/utils/send-card-data-click-event';
import { SearchDrawerName } from '../constants';
import { closeMenuOnNavigate } from '../utils/close-menu-on-navigate';
interface Props {
  href: string;
  children: React.ReactNode;
  className?: string;
  item: SearchItemWithImageViewModel;
  queryId?: string;
  onNavigate?: (e?: React.MouseEvent, href?: string) => void;
}
export default function MobileSearchLink({
  href,
  children,
  className,
  item,
  queryId,
  onNavigate
}: Props) {
  const [userToken] = useUserToken();
  const {
    closeDrawer
  } = useDrawer();
  const handleClick = (e: React.MouseEvent) => {
    sendCardDataClickEvent(userToken, item.id, queryId ?? '', item.type ?? null, item.position ?? null);
    if (onNavigate) {
      onNavigate(e, href);
    } else {
      closeMenuOnNavigate();
      closeDrawer(SearchDrawerName);
    }
  };
  return <AppNextLink prefetch={false} onClick={handleClick} href={href} className={className} data-sentry-element="AppNextLink" data-sentry-component="MobileSearchLink" data-sentry-source-file="mobile-search-link.tsx">
            {children}
        </AppNextLink>;
}